'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _startCase2 = require('lodash/startCase');

var _startCase3 = _interopRequireDefault(_startCase2);

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _is_after = require('date-fns/is_after');

var _is_after2 = _interopRequireDefault(_is_after);

var _is_same_day = require('date-fns/is_same_day');

var _is_same_day2 = _interopRequireDefault(_is_same_day);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _common = require('../common');

var _constants = require('../../constants');

var _DateTime = require('../common-formsy/DateTime');

var _DateTime2 = _interopRequireDefault(_DateTime);

var _Form = require('../common-formsy/Form');

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var DATE_FORMATS = _constants.AppConstants.DATE_FORMATS;

var DateRange = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(DateRange, _Component);

  function DateRange() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DateRange);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateRange.__proto__ || Object.getPrototypeOf(DateRange)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'showResetIcon', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DateRange, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _nextProps$value = _slicedToArray(nextProps.value, 2),
          newStart = _nextProps$value[0],
          newEnd = _nextProps$value[1];

      // Populate if props are populated


      var endChanged = newEnd && newEnd !== this.selectedEndDate,
          startChanged = newStart && newStart !== this.selectedStartDate;
      if (endChanged || startChanged) {
        this.setValue([newStart, newEnd]);
      }
    }
  }, {
    key: 'onValid',
    value: function onValid() {
      var onQueryChange = this.props.onQueryChange;

      onQueryChange(this.refForm.getModel());
    }
  }, {
    key: 'validEndDates',
    value: function validEndDates(currentDate, selectedDate) {
      var startDate = this.selectedStartDate;

      if (startDate) {
        return (0, _is_same_day2.default)(currentDate, startDate) || (0, _is_after2.default)(currentDate, startDate);
      }

      return true;
    }
  }, {
    key: 'setShowResetIcon',
    value: function setShowResetIcon() {
      this.showResetIcon = !!(this.selectedStartDate || this.selectedEndDate);
    }
  }, {
    key: 'reset',
    value: function reset() {
      var reset = this.props.reset,
          startDateTime = this.refStart,
          endDateTime = this.refEnd;


      startDateTime.resetValue();
      endDateTime.resetValue();

      reset();
      this.showResetIcon = false;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      var _value2 = _slicedToArray(value, 2),
          startValue = _value2[0],
          endValue = _value2[1],
          begin = this.refStart,
          end = this.refEnd;

      begin.setValue(startValue);
      end.setValue(endValue);
    }
  }, {
    key: 'setRefForm',
    value: function setRefForm(comp) {
      this.refForm = comp;
    }
  }, {
    key: 'setRefStart',
    value: function setRefStart(comp) {
      this.refStart = comp;
    }
  }, {
    key: 'setRefEnd',
    value: function setRefEnd(comp) {
      this.refEnd = comp;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          fieldName = _props.fieldName,
          limited = _props.limited,
          startLabel = _props.startLabel,
          endLabel = _props.endLabel,
          showReset = _props.showReset,
          _props$value = _slicedToArray(_props.value, 2),
          start = _props$value[0],
          end = _props$value[1],
          classNames = (0, _classnames2.default)('date-range', 'condensed'),
          isDateError = (0, _startCase3.default)(fieldName) + ' is not a valid date (' + DATE_FORMATS.date_edit + ')',
          isValidEndDate = limited ? this.validEndDates : null;

      return _react2.default.createElement(
        _Form2.default,
        {
          className: classNames,
          ref: this.setRefForm,
          onValid: this.onValid,
          onChange: this.setShowResetIcon
        },
        _react2.default.createElement(_DateTime2.default, {
          ref: this.setRefStart,
          name: fieldName + '_after',
          label: startLabel,
          validations: {
            isDateFormat: true,
            isRequiredFor: limited && fieldName + '_before',
            isValidStartDate: fieldName + '_before'
          },
          validationErrors: {
            isDateFormat: isDateError,
            isValidStartDate: startLabel + ' must come before the selected ' + endLabel
          },
          placeholder: startLabel,
          required: this.props.required,
          manual: true,
          value: start
        }),
        _react2.default.createElement(_common.Icon, { type: 'long-arrow-right' }),
        _react2.default.createElement(_DateTime2.default, {
          ref: this.setRefEnd,
          name: fieldName + '_before',
          label: endLabel,
          isValidDate: isValidEndDate,
          validations: {
            isDateFormat: true,
            isRequiredFor: limited && fieldName + '_after',
            isValidEndDate: fieldName + '_after'
          },
          validationErrors: {
            isDateFormat: isDateError,
            isValidEndDate: endLabel + ' must come after the selected ' + startLabel
          },
          placeholder: endLabel,
          required: this.props.required,
          manual: true,
          value: end
        }),
        showReset && this.showResetIcon && _react2.default.createElement(
          _Button2.default,
          { bsStyle: 'link', onClick: this.reset },
          _react2.default.createElement(_common.Icon, { type: 'times-circle' })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'selectedStartDate',
    get: function get() {
      var startDateTime = this.refStart;
      return startDateTime ? startDateTime.getValue() : null;
    }
  }, {
    key: 'selectedEndDate',
    get: function get() {
      var endDateTime = this.refEnd;
      return endDateTime ? endDateTime.getValue() : null;
    }
  }]);

  return DateRange;
}(_react.Component), _class3.defaultProps = {
  endLabel: 'End Date',
  limited: true,
  onQueryChange: _noop3.default,
  required: true,
  reset: _noop3.default,
  showReset: true,
  startLabel: 'Start Date',
  value: []
}, _class3.propTypes = {
  endLabel: _propTypes2.default.string,
  fieldName: _propTypes2.default.string.isRequired,
  limited: _propTypes2.default.bool,
  onQueryChange: _propTypes2.default.func,
  required: _propTypes2.default.bool,
  reset: _propTypes2.default.func,
  showReset: _propTypes2.default.bool,
  startLabel: _propTypes2.default.string,
  value: _mobxReact.propTypes.arrayOrObservableArray
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showResetIcon', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'reset', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'reset'), _class2.prototype)), _class2)) || _class) || _class;

var _default = DateRange;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DATE_FORMATS, 'DATE_FORMATS', '/app/src/components/common/DateRange.js');
  reactHotLoader.register(DateRange, 'DateRange', '/app/src/components/common/DateRange.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common/DateRange.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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